import { render, staticRenderFns } from "./TheTopbar.vue?vue&type=template&id=135b0216&scoped=true"
import script from "./TheTopbar.vue?vue&type=script&lang=js"
export * from "./TheTopbar.vue?vue&type=script&lang=js"
import style0 from "./TheTopbar.vue?vue&type=style&index=0&id=135b0216&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135b0216",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/al-khaleej/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('135b0216')) {
      api.createRecord('135b0216', component.options)
    } else {
      api.reload('135b0216', component.options)
    }
    module.hot.accept("./TheTopbar.vue?vue&type=template&id=135b0216&scoped=true", function () {
      api.rerender('135b0216', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/layout/TheTopbar.vue"
export default component.exports